import React, { useState, useEffect } from "react";
import Header from "../components/header";
import Footer from "../components/Footer";
import SidebarHeader from "../components/sidebarHeader";
import { useMediaQuery } from "react-responsive";
import axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import "./styles.css";
import { useSelector, useDispatch } from "react-redux";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { searchByHeader, loginModal } from "../Redux/authAction";
import { loginUser, logoutUser, language } from "../Redux/authAction";
import FixedHeader from "../components/Fixedheader";
import api from '../config/api';

const Category = () => {
  const { category } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [apiData, setApiData] = useState({});
  const [apiData2, setApiData2] = useState({
    title: [
      'Promotion Maker',
      'Resume Maker',
      'Employee Certificates',
      'Wedding Cards',
      'Birthday Cards',
      'Logo Maker',
      'Cover Letter',
    ]
  });

  const displayName = useSelector((state) => state.authReducer.displayName); // Moved outside
  console.log("my name is :",displayName);
  const uid = useSelector((state) => state.authReducer.uid); // Moved outside
  const email = useSelector((state) => state.authReducer.email); // Moved outside
  const packageid = useSelector((state) => state.authReducer.packageid); // Moved outside
  const status = useSelector((state) => state.authReducer.status); // Moved outside
  const prev_temppkgid = useSelector((state) => state.authReducer.temp_pkgid); // Moved outside

  const [alltemplates, setAlltemplates] = useState([]);
  const [mySaveTemplates, setMySaveTemplates] = useState([]);
  const [show, setShow] = useState(false);
  const userID = useSelector((state) => state.authReducer.uid);
  const search = useSelector((state) => state.authReducer.search);
  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );
  console.log("AUthenticated",isAuthenticated);

  useEffect(() => {
    const handleReload = () => {
      if (performance.navigation.type === 1) {
        navigate("/");
      }
    };

    window.addEventListener("load", handleReload);

    return () => {
      window.removeEventListener("load", handleReload);
    };
  }, [navigate]);

  const [selectedCategory, setSelectedCategory] = useState({
    title: "",
    icons: "",
  });
  const [userTemplates, setUserTemplates] = useState([]);
  const [newstate, setnewstate] = useState('1');

  useEffect(() => {
    const fetchData = async () => {
      try {
        setShow(false);
        const response = await axios.get(
          api.getUrl(api.ENDPOINTS.GET_CATEGORIES)
        );
        const titles = response.data.map((item) => item.title);
        const icons = response.data.map((item) => item.icon_path);
        setApiData({
          title: titles,
          icons: icons,
        });

        let apiResponse;
        if (search) {
          apiResponse = await axios.get(
            api.getUrl(api.ENDPOINTS.GET_TEMPLATES_BY_NAME, { name: category })
          );
        } else {
          apiResponse = await axios.get(
            api.getUrl(api.ENDPOINTS.TEMPLATES_BY_CATEGORY, { title: category })
          );
        }

        setAlltemplates(apiResponse.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [category, mySaveTemplates.title, search]);

  useEffect(() => {
    const fetchCategoryData = async () => {
      if (selectedCategory.title) {
        try {
          const categoryResponse = await axios.get(
            api.getUrl(api.ENDPOINTS.TEMPLATES_BY_CATEGORY, { title: selectedCategory.title })
          );
          setAlltemplates(categoryResponse.data);
        } catch (error) {
          console.error("Error fetching category data:", error);
        }
      }
    };

    fetchCategoryData();
  }, [selectedCategory.title, category, search]);

  useEffect(() => {
    const fetchUserTemplates = async () => {
      if (show) {
        try {
          const userTemplatesResponse = await axios.get(
            api.getUrl(api.ENDPOINTS.GET_USER_TEMPLATES, { edited_by: userID })
          );

          console.log("user templates data: ", userTemplatesResponse);
          setUserTemplates(userTemplatesResponse.data);

        } catch (error) {
          console.error("Error fetching user templates:", error);
        }
      }
    };

    fetchUserTemplates();
  }, [show, search, selectedCategory.title, userID]);

  const handleClickTitle = async (title) => {
    setShow(false);
    dispatch(searchByHeader(false));

    if (title === category || search === false) {
      try {
        const apiResponse = await axios.get(
          api.getUrl(api.ENDPOINTS.TEMPLATES_BY_CATEGORY, { title: title })
        );
        setAlltemplates(apiResponse.data);
      } catch (error) {
        console.error("Error fetching templates:", error);
      }
    } else {
      setSelectedCategory({
        title: title,
        icons: apiData.icons[apiData.title.indexOf(title)],
      });
    }
  };

  const handleTemplateClick = (templateId, templateTitle, templetepath, templatepackageid) => {

    const temp_pkgid = templatepackageid;
    const temp_id = templateId;
    console.log(displayName,uid,packageid, status,temp_pkgid, "templateid:",temp_id);
    if (uid !== null) {
      dispatch(loginUser({ displayName, uid, email, packageid, status, temp_pkgid,temp_id }));
    }
    console.log("template package id: ",temp_pkgid,"User Package id: ",packageid);
    const selectedTemplate = alltemplates.find(temp => temp.id === templateId);
    if (!selectedTemplate) return;
    if (selectedTemplate.category === "50") {
      navigate(`/pages/specificbuilder/${templetepath}`);
    } else if (selectedTemplate.category === "52") {
      navigate(`/CoverBuilder/${templetepath}`);
    } else {
      // Default behavior or fallback for other categories
      navigate(`/ResumeMaker/temp/${templateId}`);
    }
  };

  
  const handleUserTemplateClick = (templateId, templateTitle, templetepath, templatepackageid) => {

    const temp_pkgid = templatepackageid;
    const temp_id = templateId;
    console.log(displayName,uid,packageid, status,temp_pkgid, "templateid:",temp_id);
    if (uid !== null) {
      dispatch(loginUser({ displayName, uid, email, packageid, status, temp_pkgid,temp_id }));
    }
    console.log("template package id: ",temp_pkgid,"User Package id: ",packageid);
    const selectedTemplate = userTemplates.find(temp => temp.id === templateId);
    if (!selectedTemplate) return;
    if (selectedTemplate.category === "50") {
      navigate(`/pages/specificbuilder/${templetepath}`);
    } else if (selectedTemplate.category === "52") {
      navigate(`/CoverBuilder/${templetepath}`);
    } else {
      navigate(`/ResumeMaker/save/${templateId}`);
    }
  };

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1150px)",
  });

  return (
    <div style={{ color: "black" }}>
      <div>{isDesktopOrLaptop ? <Header /> : <SidebarHeader />}</div>
      <div className="flex flex-col lg:flex-row">
        {isAuthenticated ? (
          <div>
            {isDesktopOrLaptop ? (
              <div className="w-full lg:w-[300px]">
                <FixedHeader
                  apiData={apiData}
                  selectedCategory={selectedCategory}
                  setSelectedCategory={setSelectedCategory}
                  setMySaveTemplates={setMySaveTemplates}
                  mySaveTemplates={mySaveTemplates}
                  setShow={setShow}
                />
              </div>
            ) : null}
          </div>
        ) : null}

        <div
          className={
            isAuthenticated
              ? "w-full lg:w-[calc(100%-300px)] px-3 sm:px-5"
              : "w-full px-3 sm:px-5"
          }
          style={
            isAuthenticated
              ? {}
              : { margin: "20px calc((100% - 176px) / 24)" }
          }
        >
          <div
            className="h-[200px] sm:h-[280px] w-full mt-[80px]  md:mt-[80px] rounded-xl flex flex-col justify-center items-center bg-gradient-to-r from-purple-600 via-purple-600 to-purple-600"
            style={{
              padding: "0 20px",
            }}
          >
            <p
              className="text-[18px] sm:text-[24px] md:text-[32px]  mt-4 text-center text-white font-semibold py-4"
              style={{
                fontFamily: "poppins",
              }}
            >
              What Will You Design Today 
            </p>
            <ul
              className="flex flex-wrap justify-around pb-5 sm:pb-10 md:gap-10 gap-4"
            >
              {apiData2.title &&
                apiData2.title.map((title, index) => (
                  <li
                    key={index}
                    onClick={() => handleClickTitle(title)}
                    className="flex flex-col items-center gap-2 text-white font-medium cursor-pointer"
                  >
                    <button onClick={() => setnewstate('2')}>
                      <div className="h-[50px] w-[50px] sm:h-[60px] sm:w-[60px] md:h-[70px] md:w-[70px] rounded-full flex justify-center items-center p-3">
                        <LazyLoadImage
                          src={`/herosection/${title}.png`}
                          alt={"image"}
                        />
                      </div>
                    </button>
                    <button onClick={() => setnewstate('3')}>
                      <p className="text-[10px] sm:text-[12px] md:text-[14px]">
                        {title}
                      </p>
                    </button>
                  </li>
                ))}
            </ul>
          </div>

          <div
            className="flex flex-wrap gap-4 mt-6"
            style={{
              fontFamily: "poppins",
            }}
          >
            {(show ? userTemplates : alltemplates).map((temp) => {
              return (
                <div
                  onClick={() => show ? handleUserTemplateClick(temp.id, temp.title,temp.templetepath, temp.pkgid) : handleTemplateClick(temp.id, temp.title,temp.templetepath, temp.pkgid) }
                  key={temp?.id}
                  className="w-[23%] bg-white shadow-md rounded-lg overflow-hidden cursor-pointer"
                >
                  <NavLink
                    to={isAuthenticated ? "#" : "/login"} // Placeholder to prevent direct navigation
                    className="hover:no-underline"
                    onClick={(e) => {
                      if (!isAuthenticated) {
                        e.preventDefault();
                        dispatch(loginModal(true));
                      }
                    }}
                  >
                    <div className="overflow-hidden">
                      {show ? (
                        <LazyLoadImage
                          src={`${api.API_URL}/aapi/userTempletes/${temp.imagepath}`}
                          alt={temp.title}
                          className="h-full w-full object-cover"
                        />
                      ) : (
                        <LazyLoadImage
                          src={`${api.API_URL}/aapi/templetes/${temp.imagepath}`}
                          alt={temp.title}
                          className="h-full w-full object-cover"
                        />
                      )}
                    </div>
                    <p
                      className="px-2 py-2 text-gray-700 text-xs sm:text-sm"
                    >
                      {temp.title}
                    </p>
                  </NavLink>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Category;
